module.exports = "/build/web/svg/logo.f877a6ceed82dbe46269c732d55e533d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/logo.svg
// module id = 117
// module chunks = 24